export const GET_EMAIL_SETTINGS = 'GET_EMAIL_SETTINGS'
export const UPDATE_EMAIL_SETTING = 'UPDATE_EMAIL_SETTING'
